<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">{{ inputData.title }}</h2>
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="assureForm" class="p-4 bg-white custom-dialog-content">
  <div class="row g-3">

    <!-- Type de personne -->
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Personne</mat-label>
        <mat-select formControlName="personne" (selectionChange)="onChange($event)">
          <mat-option value="" disabled>Choisir le type de personne</mat-option>
          <mat-option value="physique">Physique</mat-option>
          <mat-option value="morale">Morale</mat-option>
        </mat-select>
        @if (assureForm.get('personne')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <!-- Formulaire Personne Physique -->
    @if(assureForm.get('personne')?.value == 'physique'){
      
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nom</mat-label>
          <input matInput type="text" formControlName="firstname" placeholder="Entrez le nom de l'assure">
          @if (assureForm.get('firstname')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>
      
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Prénom</mat-label>
          <input matInput type="text" formControlName="lastname" placeholder="Entrez le prenom de l'assure">
          @if (assureForm.get('lastname')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Genre</mat-label>
          <mat-select formControlName="gender">
            <mat-option value="" disabled="">Choisir un genre</mat-option>
            <mat-option value="masculin">Masculin</mat-option>
            <mat-option value="feminin">Feminin</mat-option>
          </mat-select>
          @if (assureForm.get('gender')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>
      
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Profession</mat-label>
          <input matInput type="text" formControlName="profession" placeholder="Entrez la profession de l'assure">
          @if (assureForm.get('profession')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>NIU</mat-label>
          <input matInput type="text" formControlName="niu" placeholder="Entrez le niu">
          @if (assureForm.get('')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>

    } @else {
      <!-- Formulaire Personne Morale -->

      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Société</mat-label>
          <input matInput type="text" formControlName="societe" placeholder="Entrez le nom de la societe">
          @if (assureForm.get('societe')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>
      
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Forme Juridique</mat-label>
          <mat-select formControlName="forme_juridique">
            <mat-option value="SA">SA</mat-option>
            <mat-option value="SARL">SARL</mat-option>
            <mat-option value="SUARL">SUARL</mat-option>
            <mat-option value="autre">Autre</mat-option>
          </mat-select>
          @if (assureForm.get('forme_juridique')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Représentant</mat-label>
          <input matInput type="text" formControlName="representant" placeholder="Entrez le nom du  representant">
          @if (assureForm.get('representant')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>
      
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Profession du représentant</mat-label>
          <input matInput type="text" formControlName="profession" placeholder="Entrez la profession du representant">
          @if (assureForm.get('profession')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>NIU</mat-label>
          <input matInput type="text" formControlName="niu" placeholder="Entrez le niu">
          @if (assureForm.get('')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>
      
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>R.C</mat-label>
          <input matInput type="text" formControlName="niu" placeholder="Entrez le R.C">
          @if (assureForm.get('rc')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
      </div>

    }

    <!-- Coordonnées communes -->
    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tel</mat-label>
        <input matInput type="text" formControlName="tel" [readonly]="inputData.update && inputData.data?.tel" placeholder="Entrez le numero de tel.">
        @if (assureForm.get('tel')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>
    
    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Adresse</mat-label>
        <input matInput type="text" formControlName="adresse" placeholder="Entrez le nom du proprietaire">
        @if (assureForm.get('adresse')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput type="text" formControlName="email" placeholder="Entrez une email">
        @if (assureForm.get('email')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (assureForm.get('email')?.hasError('email')) {<mat-error>email invalid</mat-error>}
      </mat-form-field>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button [disabled]="loadingbtn()" mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="resetForm()">Fermer</button>
  
  @if (inputData.update) {
    <button [disabled]="assureForm.invalid || loadingbtn()" mat-flat-button color="primary" class="px-4 spinner-btn" (click)="onUpdate()">
      <span>Modifier</span>
      @if (loadingbtn()) {<mat-spinner diameter="16" class="ms-2"></mat-spinner>}
    </button>
  } @else {
    <button [disabled]="assureForm.invalid || loadingbtn()" mat-flat-button color="primary" class="px-4 spinner-btn" (click)="onAdd()">
      <span>Enregistrer</span>
      @if (loadingbtn()) {<mat-spinner diameter="16" class="ms-2"></mat-spinner>}
    </button>
  }
</mat-dialog-actions>
